import React from "react";
import BulkCancelProgressToast from "features/trades/CancelTrade/BulkTradesProgressToast.tsx";
import BulkBotsProgressToast from "features/bots/BulkBotsProgressToast";
import BulkSignalsProgressToast from "features/signals/CancelSignal/BulkSignalsProgressToast";
import useNotification from "utils/hooks/useNotification";
import { useRefValue } from "@shared/utils/hooks/misc";

const ProgressToasts: React.FC = () => {
  const [notificationApi, contextHolder] = useNotification();
  const notificationApiRef = useRefValue(notificationApi);

  return (
    <>
      {contextHolder}
      <BulkCancelProgressToast notificationApiRef={notificationApiRef} />
      <BulkBotsProgressToast notificationApiRef={notificationApiRef} />
      <BulkSignalsProgressToast notificationApiRef={notificationApiRef} />
    </>
  );
};

export default ProgressToasts;
